<template>
  <cadastro-base
    :salvar="salvar"
    :cancelar="cancelar"
  >
    <template slot="conteudo">
      <div slot="modal-title">
        <h5>Configuração de envio automático de documentos por rotinas</h5>
        <fieldset class="font-weight-bold text-muted">
          Nos informe a forma que deseja que o sistema faça o envio dos documentos de forma automáticas.
        </fieldset>
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </div>

      <!-- <b-tabs>
        <b-tab> -->
      <!-- <template #title> -->
      <h4>
        Certidões
        <a
          style="cursor: pointer;"
          @click="$refs.modalInfo.show()"
        >
          <feather-icon
            style="margin-left: 5px;"
            icon="InfoIcon"
            size="14"
            stroke-width="3"
            class="text-primary"
          />
        </a>
      </h4>

      <b-modal
        ref="modalInfo"
        ok-only
        ok-title="OK"
        centered
        size="lg"
        hide-header
      >
        <div class="text-center mb-2">
          <b-avatar
            variant="light-warning"
            size="60"
            class="mb-1"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="28"
            />
          </b-avatar>
          <h4 class="font-weight-bold">
            <feather-icon
              icon="FileTextIcon"
              class="mr-50"
            />
            Informações sobre configuração da tela!
          </h4>
        </div>

        <div class="mb-2">
          <h6 class="font-weight-bold">
            <feather-icon
              icon="InfoIcon"
              size="13"
              class="mr-25"
            /> Informações sobre o envio automático
          </h6>
          <p class="mb-50">
            O envio automático de documentos pode ser configurado para todas as empresas ou apenas para um <strong>grupo específico</strong> de empresas.
          </p>
          <p class="font-weight-bold mb-25">
            <feather-icon
              icon="SearchIcon"
              size="13"
              class="mr-25"
            /> Seleção de empresas
          </p>
          <p class="mb-0">
            Para definir o envio apenas para algumas empresas, utilize o <strong>Filtro Avançado</strong> e selecione as empresas desejadas.
          </p>
          <p>
            Caso <strong>nenhuma empresa</strong> seja selecionada, o sistema considerará automaticamente todas as empresas cadastradas em sua base de dados.
          </p>
        </div>

        <div class="mb-2">
          <h6 class="font-weight-bold">
            <feather-icon
              icon="CheckSquareIcon"
              size="13"
              class="mr-25"
            /> Condições para que o envio ocorra
          </h6>
          <p class="mb-25">
            No momento da execução do envio, o sistema enviará o documento apenas para empresas que atenderem aos seguintes critérios:
          </p>
          <ul class="mb-0 pl-1">
            <li>Possuam <strong>e-mail cadastrado</strong></li>
            <li>Possuam <strong>CND com status Regular</strong></li>
            <li>Atendam às configurações definidas nesta tela</li>
          </ul>
        </div>

        <div class="mb-2">
          <h6 class="font-weight-bold">
            <feather-icon
              icon="SettingsIcon"
              size="13"
              class="mr-25"
            /> Opção „Não enviar„
          </h6>
          <p class="mb-0">
            Ao selecionar a opção <strong>„Não enviar„</strong>, todos os demais campos da configuração serão automaticamente desabilitados, impedindo a definição de regras de envio.
          </p>
        </div>

        <div class="mb-2">
          <h6 class="font-weight-bold">
            <feather-icon
              icon="ZapIcon"
              size="13"
              class="mr-25"
            /> Boas práticas
          </h6>
          <p class="mb-25">
            Para maior controle do envio automático, recomenda-se:
          </p>
          <ul class="mb-0 pl-1">
            <li>Definir grupos de empresas utilizando o Filtro Avançado</li>
            <li>Verificar se os e-mails das empresas estão atualizados</li>
            <li>Confirmar se as empresas possuem monitoramento ativo de CND</li>
          </ul>
        </div>

        <p class="text-center font-weight-bold mt-2 mb-0">
          Atenciosamente, Equipe Monitor Contábil
        </p>
      </b-modal>
      <!-- </template> -->

      <b-row>
        <b-col
          cols="12"
          class="mb-2"
        >
          <fieldset class="font-weight-bold mb-1">
            Selecione o tipo de envio automático que você deseja.
          </fieldset>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          v-for="rotina in $options.ROTINAS"
          :key="rotina.tipoRotina"
          cols="auto"
          class="mb-2"
          style="min-width: 200px;"
        >
          <fieldset class="font-weight-bold mb-1">
            {{ rotina.titulo }}
          </fieldset>

          <b-form-group class="mb-1">
            <b-form-radio
              v-model="form[rotina.campo].tipoEnvio"
              :name="`tipoEnvio-${rotina.tipoRotina}`"
              :value="0"
            >
              Não enviar
            </b-form-radio>
            <b-form-radio
              v-model="form[rotina.campo].tipoEnvio"
              :name="`tipoEnvio-${rotina.tipoRotina}`"
              :value="1"
              class="mt-50"
            >
              Na atualização
            </b-form-radio>
            <b-form-radio
              v-model="form[rotina.campo].tipoEnvio"
              :name="`tipoEnvio-${rotina.tipoRotina}`"
              :value="2"
              class="mt-50"
            >
              Dia selecionado
            </b-form-radio>
          </b-form-group>

          <div class="d-flex align-items-center mt-1">
            <b-form-input
              :id="`diaEnvio-${rotina.tipoRotina}`"
              v-model="form[rotina.campo].diaEnvio"
              type="number"
              min="1"
              max="31"
              placeholder="Dia"
              :disabled="form[rotina.campo].tipoEnvio !== 2"
              :state="diaInvalido(rotina.campo) ? false : null"
              style="max-width: 80px;"
              @blur="formatarDia(rotina.campo)"
            />
            <empresas-envio-automatico
              :tipo-rotina="rotina.tipoRotina"
              :titulo-rotina="rotina.titulo"
              :empresas-ids="form[rotina.campo].empresasIds"
              @atualizar="atualizarEmpresas($event)"
            />
            <historico-envio-automatico
              v-if="form[rotina.campo].tipoEnvio !== 0"
              :tipo-rotina="rotina.tipoRotina"
              :titulo-rotina="rotina.titulo"
            />
          </div>
        </b-col>
      </b-row>

      <fieldset
        style="margin-top: 10px;"
        class="font-weight-bold text-muted"
      >
        O envio "Na atualização" ocorre sempre que o documento for atualizado pelo sistema. O envio "Dia selecionado" ocorre mensalmente no dia configurado.
      </fieldset>
      <!-- </b-tab> -->
      <!--
          Futuras abas: adicionar novos <b-tab> aqui para outros tipos de documentos.
          Cada aba deve seguir o mesmo padrão: array de rotinas, form com tipoEnvio/diaEnvio/empresasIds,
          e os mesmos componentes EmpresasEnvioAutomatico + HistoricoEnvioAutomatico.
        -->
      <!-- </b-tabs> -->
    </template>
  </cadastro-base>
</template>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import api from './shared/services/api'
import EventBus from '../shared/mixins/event-bus/eventBus'
import apiTermos from '../shared/services/api-termos'

const ROTINAS = [
  { tipoRotina: 1, titulo: 'RFB/PGFN', campo: 'cndRfbPgfn' },
  { tipoRotina: 2, titulo: 'FGTS', campo: 'cndFgts' },
  { tipoRotina: 3, titulo: 'Trabalhista', campo: 'cndTrabalhista' },
  { tipoRotina: 4, titulo: 'Estadual', campo: 'cndEstadual' },
  { tipoRotina: 10, titulo: 'Municipal', campo: 'cndMunicipal' },
]

function configVazia() {
  return { tipoEnvio: 0, diaEnvio: null, empresasIds: [] }
}

function estadoInicial() {
  const state = {}
  ROTINAS.forEach(r => { state[r.campo] = configVazia() })
  return state
}

export default {
  name: 'EnvioAutomaticoView',
  ROTINAS,
  components: {
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
    EmpresasEnvioAutomatico: () => import('./shared/components/EmpresasEnvioAutomatico.vue'),
    HistoricoEnvioAutomatico: () => import('./shared/components/HistoricoEnvioAutomatico.vue'),
  },
  data() {
    return {
      form: estadoInicial(),
    }
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        ROTINAS.forEach(r => {
          if (form[r.campo].tipoEnvio !== 2) {
            // eslint-disable-next-line no-param-reassign
            form[r.campo].diaEnvio = null
          }
        })
      },
    },
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getConfigs()
        .then(payload => {
          const configs = payload.data
          configs.forEach(config => {
            const rotina = ROTINAS.find(r => r.tipoRotina === config.tipoRotina)
            if (rotina) {
              this.form[rotina.campo] = {
                tipoEnvio: config.tipoEnvio,
                diaEnvio: config.diaEnvio || null,
                empresasIds: config.empresasIds || [],
              }
            }
          })
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.push({ name: 'dashboard-analitico' })
    },
    diaInvalido(campo) {
      const config = this.form[campo]
      if (config.tipoEnvio !== 2) return false
      const dia = parseInt(config.diaEnvio, 10)
      return !config.diaEnvio || Number.isNaN(dia) || dia < 1 || dia > 31
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const invalidas = ROTINAS.filter(r => this.diaInvalido(r.campo))
        if (invalidas.length > 0) {
          const nomes = invalidas.map(r => r.titulo).join(', ')
          reject(new Error(`Informe um dia válido (1 a 31) para: ${nomes || ''}`))
          return
        }

        apiTermos.getPendentes([2])
          .then(r => {
            if (r.data?.length) {
              EventBus.$emit('termosPendentes', r.data)
              EventBus.$once('termoAceito', () => this.executarSalvamento(resolve, reject))
            } else {
              this.executarSalvamento(resolve, reject)
            }
          })
          .catch(() => this.executarSalvamento(resolve, reject))
      })
    },

    executarSalvamento(resolve, reject) {
      const promises = ROTINAS.map(rotina => {
        const config = this.form[rotina.campo]
        return api.salvarConfig({
          tipoRotina: rotina.tipoRotina,
          tipoEnvio: config.tipoEnvio,
          diaEnvio: config.tipoEnvio === 2 ? config.diaEnvio : null,
        })
      })

      Promise.all(promises)
        .then(() => {
          resolve('Configurações de envio automático salvas com sucesso')
        })
        .catch(error => {
          reject(error || 'Erro ao salvar configurações')
        })
    },
    formatarDia(campo) {
      const valor = this.form[campo].diaEnvio
      if (valor && +valor > 0 && +valor < 10) {
        this.form[campo].diaEnvio = `0${+valor}`
      }
    },
    atualizarEmpresas({ tipoRotina, empresasIds }) {
      const rotina = ROTINAS.find(r => r.tipoRotina === tipoRotina)
      if (rotina) {
        this.form[rotina.campo].empresasIds = empresasIds
      }
    },
  },
}
</script>
